import React from "react";
import Button from "@components/Button";
import Icon from "@components/Icon";

interface ConnectionTargetCardProps {
    iconName: string;
    title: string;
    description: string;
    iconColorClass?: string;
    onChoose: () => void;
}

const ConnectionTargetCard: React.FC<ConnectionTargetCardProps> = ({
    iconName,
    title,
    description,
    iconColorClass = "",
    onChoose,
}) => (
    <div className="flex min-h-[208px] flex-1 flex-col gap-4 rounded border border-light-50 bg-light-02 p-4">
        <div className="flex flex-1 flex-col gap-1">
            <div className="flex flex-col gap-2">
                <div className="flex size-11 items-center justify-center rounded-[6px] border border-dark-10 bg-white">
                    <Icon
                        name={iconName}
                        width={24}
                        height={24}
                        className={iconColorClass}
                    />
                </div>
                <h3 className="text-[14px] font-semibold leading-6 text-gray-100">{title}</h3>
            </div>
            <p className="text-[14px] font-normal leading-6 text-gray-60 max-w-[400px]">{description}</p>
        </div>
        <Button
            label="Choose"
            type="button"
            variant="primary"
            size="small"
            className="!mt-auto !h-8 !min-h-8 !w-auto !self-start !rounded !px-3 !py-2 !text-[14px] !font-medium !leading-4 !normal-case"
            onClick={onChoose}
        />
    </div>
);

export default React.memo(ConnectionTargetCard);